import { Redirect } from 'expo-router';

/**
 * Alias: /refer → /referrals. People type/share the short form; without
 * this route it falls into the [slug] deal catch-all and dead-ends.
 */
export default function ReferAlias() {
  return <Redirect href="/(tabs)/referrals" />;
}
